export enum SignatureFormat {
  TEXT = 'text/plain',
  POINTS = 'points/json',
}

export enum SignatureMode {
  DRAW = 'draw',
  TYPE = 'type',
  UPLOAD = 'upload',
}

export enum SignatureView {
  DRAW = 'draw',
  TYPE = 'type',
  IMAGE = 'image',
  UPLOAD = 'upload',
}
